import { WSPillProps } from "@wingspanhq/fe-component-library";
import { InvoiceRow, InvoiceStatus } from "@wingspanhq/wingspan-api-sdk";

/**
 * Status pill for an invoice row, keyed directly on the SDK's raw
 * `InvoiceStatus` — no FE-derived status.
 */
export const getInvoiceStatusPillProps = (invoice: InvoiceRow): WSPillProps => {
  switch (invoice.status) {
    case InvoiceStatus.CANCELLED:
      return { theme: "neutral", text: "Cancelled" };

    case InvoiceStatus.CREATED:
      return { theme: "neutral", icon: "draft", text: "Draft" };

    case InvoiceStatus.PENDING:
    case InvoiceStatus.DISPUTED:
    case InvoiceStatus.RETURNED:
      return { theme: "warning", icon: true, text: "Action required" };

    case InvoiceStatus.OPENED:
    case InvoiceStatus.OVERDUE:
      return { theme: "neutral", icon: "time", text: "Awaiting client" };

    case InvoiceStatus.PAYMENT_IN_TRANSIT:
      return { theme: "blue", icon: "send-mail", text: "In-progress" };

    case InvoiceStatus.PAID_OFF_PLATFORM:
      return { theme: "neutral", icon: "paperclip", text: "Off-platform" };

    case InvoiceStatus.PAID:
    case InvoiceStatus.PARTIALLY_PAID:
      return { theme: "success", icon: true, text: "Deposited" };

    case InvoiceStatus.REFUNDED:
    case InvoiceStatus.PARTIALLY_REFUNDED:
      return { theme: "neutral", icon: "undo", text: "Refunded" };

    default:
      return { theme: "neutral", text: "Unknown" };
  }
};
